import React from "react";
import { differenceInCalendarDays } from "date-fns";
import { useTranslation } from "i18n";
import { checkIsCD } from "shared-auth";
import { WarningBaseIcon } from "assets";
import { IBillingApiResponse } from "services/api/BillingApi/BillingApi";
import { getCheckoutLink } from "helpers/getCheckoutLink";
import { BASE_PATH } from "config/common";
import { useValidAddressOrRedirectAction } from "../hooks/useValidAddressOrRedirectAction";
import NotificationBanner from "../NotificationBanner";

interface Props {
  performerSubscriptionData?: IBillingApiResponse;
}

const RenewSubscriptionBanner = ({ performerSubscriptionData }: Props) => {
  const { t } = useTranslation();

  const { address, subscription } = performerSubscriptionData || {};

  const reactivationRedirect = getCheckoutLink({
    planCode: subscription?.planCode,
  });

  const returnPath = checkIsCD() ? BASE_PATH : reactivationRedirect;

  const handleRenew = useValidAddressOrRedirectAction({
    address,
    redirect: reactivationRedirect,
    returnPath,
  });

  return (
    <NotificationBanner
      messageHtml={t("common:banner.renew.message", {
        date: differenceInCalendarDays(
          new Date(subscription?.currentTermEndsAt || ""),
          new Date()
        ),
      })}
      buttons={[
        {
          title: t("common:button.label.renew"),
          text: t("common:button.label.renew"),
          href: reactivationRedirect,
          onClick: handleRenew,
        },
      ]}
      icon={
        <WarningBaseIcon
          width={24}
          height={24}
          className="mr-2 text-color-brand-one"
        />
      }
    />
  );
};

export default RenewSubscriptionBanner;
